export default __webpack_public_path__ + "static/media/bell.5846d4b1.png";